import { gql } from "@apollo/client";

export const PAYMENT_REQUESTS_FOR_TEAM_PURCHASES = gql`
  query PaymentRequestsForTeamPurchases {
    paymentRequestsForTeamPurchases {
      _id
      invoiceNumber
      status
      grandTotal
      currency
      dueDate
      sentAt
      createdDateISO
      renewablePurchaseId
      organizationId
      productTitle
      recipientName
    }
  }
`;
